import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import ListIcon from '@mui/icons-material/List';
import React, { memo, useState } from 'react';
import {
  IconButton, Stack, Tooltip, Typography,
} from '@mui/material';
import { LinkToLRConnect, QuestionAssetsPanel } from 'components/Question/QuestionAssets';
import { ReactComponent as LiveRampLogoBlack } from 'assets/logo/liveRampLogoBlack.svg';


export const QuestionTypeCell = memo(({ row }) => {
  const text = row.isUserListQuestion ? 'List Question' : 'Analytical Question';
  const [isSidePanelOpen, setIsSidePanelOpen] = useState(false);

  const onPanelClose = () => {
    setIsSidePanelOpen(false);
  };

  return (
    <Stack direction='row' gap={1}>
      <Tooltip
        title={text}
        arrow
        placement='top'
      >
        {row.isUserListQuestion ? (
          <ListIcon />
        ) : (
          <AutoGraphIcon />
        )}
      </Tooltip>

      {row.isUserListQuestion && row.isAsset && (
        <>
          <Tooltip
            title={(
              <Stack>
                <Typography>Segmentation Enabled.</Typography>
                <Typography>Click to view Segmentation Tree.</Typography>
              </Stack>
            )}
            arrow
            placement='top'
          >
            <IconButton onClick={() => setIsSidePanelOpen(true)}>
              <LiveRampLogoBlack width={20} />
            </IconButton>
          </Tooltip>

          <LinkToLRConnect />
        </>
      )}

      {isSidePanelOpen && (
        <QuestionAssetsPanel
          questionId={row.ID}
          onPanelClose={onPanelClose}
        />
      )}
    </Stack>
  );
});

QuestionTypeCell.displayName = 'QuestionTypeCell';
